

























import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import RemplacementsInput from "./RemplacementEditPartials/RemplacementsInput.vue";
import moment from "moment";
export default {
    name: "RecurrenceInterventionRemplacementEdit",
    components: { RemplacementsInput },
    props: {
        recurrenceIntervention: RecurrenceIntervention,
    },
    data() {
        return {
            futureRemplacements: [],
            pastRemplacements: [],
        };
    },
    created() {
        let today = moment().format("YYYY-MM-DD");
        this.futureRemplacements = _.filter(
            this.recurrenceIntervention.remplacements,
            function (remplacement) {
                return remplacement.start_date >= today;
            }
        );
        this.pastRemplacements = _.filter(
            this.recurrenceIntervention.remplacements,
            function (remplacement) {
                return remplacement.start_date < today;
            }
        );
    },
};
